import React, { useCallback, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Empty, Select, Space, Spin, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import api from './api';
import '../../style/blog.css';

export default function BlogListPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tag = searchParams.get('tag') || undefined;
  const [data, setData] = useState(null);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPosts = useCallback(async (currentTag) => {
    setLoading(true);
    try {
      const res = await api.get('/posts', { params: { tag: currentTag, page: 0, size: 20 } });
      setData(res.data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPosts(tag);
  }, [tag, fetchPosts]);

  useEffect(() => {
    api.get('/tags').then((res) => setTags(res.data));
  }, []);

  return (
    <div className="blog-page">
      <Typography.Title level={2}>블로그</Typography.Title>
      <Space style={{ marginBottom: 24 }}>
        <Select
          allowClear
          placeholder="태그 필터"
          style={{ width: 160 }}
          value={tag}
          onChange={(value) => setSearchParams(value ? { tag: value } : {})}
          options={tags.map((t) => ({ label: t, value: t }))}
        />
      </Space>
      {loading ? (
        <Spin />
      ) : data?.posts?.length ? (
        data.posts.map((post) => (
          <div className="blog-list-item" key={post.slug}>
            <Link to={tag ? `/blog/${post.slug}?tag=${encodeURIComponent(tag)}` : `/blog/${post.slug}`}>
              <Typography.Title level={4} style={{ marginBottom: 4 }}>
                {post.title}
              </Typography.Title>
            </Link>
            <Typography.Text type="secondary">
              {post.published_at ? dayjs(post.published_at).format('YYYY.MM.DD') : ''}
            </Typography.Text>
            <div style={{ margin: '8px 0' }}>
              {post.tags?.map((t) => (
                <Tag key={t}>{t}</Tag>
              ))}
            </div>
            {post.summary && <Typography.Paragraph>{post.summary}</Typography.Paragraph>}
          </div>
        ))
      ) : (
        <Empty description="아직 작성된 글이 없어요" />
      )}
    </div>
  );
}
